import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';

@Component({
  selector: 'dl-file-format-dialog',
  standalone: true,
  imports: [OneWebComponentsAngularModule],
  templateUrl: './file-format-dialog.component.html',
  styleUrls: ['./file-format-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileFormatDialogComponent implements OnInit {
  @Output() formatSelected = new EventEmitter<string | null>();
  constructor() {}

  ngOnInit(): void {}
 

  selectFormat(format: string | null): void {
    this.formatSelected.emit(format);
  }

}
